import type { UnreadStats } from '../../model/types'

import css from './UnreadCount.module.scss'
export function UnreadCount({
	inbox = 0
}: Pick<Partial<UnreadStats>, 'inbox'>) {
	return inbox > 0 && <span className={css.count}>{inbox}</span>
}
